import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SignIn, SignUp, useAuth } from "@clerk/react";
import { Toaster } from "./components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Browse from "./pages/Browse";
import CarDetail from "./pages/CarDetail";
import Dealers from "./pages/Dealers";
import DealerStore from "./pages/DealerStore";
import Sell from "./pages/Sell";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Cities from "./pages/Cities";
import CityPage from "./pages/CityPage";
import { FavoritesProvider } from "./lib/favorites";
import { LocationProvider } from "./lib/location";
import LocationPrompt from "./components/LocationPrompt";
import { InstallProvider } from "./components/InstallApp";
import { RealtimeProvider } from "./lib/realtime";
import BottomNav from "./components/BottomNav";
import Chat from "./pages/Chat";

const Protected = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const { pathname, search } = useLocation();
  if (!isLoaded) return <div className="pt-40 text-center text-gray-500" data-testid="auth-loading">Loading...</div>;
  if (!isSignedIn) return <Navigate to={`/sign-in?redirect_url=${encodeURIComponent(window.location.origin + pathname + search)}`} replace />;
  return children;
};

const AuthPage = ({ children }) => (
  <div className="min-h-screen pt-32 pb-16 flex items-center justify-center px-4" data-testid="auth-page">{children}</div>
);

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <FavoritesProvider>
          <LocationProvider>
          <InstallProvider>
          <RealtimeProvider>
          <ScrollTop />
          <LocationPrompt />
          <Header />
          <main className="min-h-screen pb-20 lg:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cars" element={<Browse />} />
              <Route path="/cars/:id" element={<CarDetail />} />
              <Route path="/dealers" element={<Dealers />} />
              <Route path="/dealers/:id" element={<DealerStore />} />
              <Route path="/sell" element={<Protected><Sell /></Protected>} />
              <Route path="/admin" element={<Protected><Admin /></Protected>} />
              <Route path="/cities" element={<Cities />} />
              <Route path="/city/:state/:city" element={<CityPage />} />
              <Route path="/chat" element={<Protected><Chat /></Protected>} />
              <Route path="/chat/:id" element={<Protected><Chat /></Protected>} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
              <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            </Routes>
          </main>
          <Footer />
          <BottomNav />
          <Toaster theme="dark" position="bottom-right" />
          </RealtimeProvider>
          </InstallProvider>
          </LocationProvider>
          </FavoritesProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
